var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgValuepropsCheck2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  stroke: "#333",
  strokeWidth: 0.25,
  d: "M20.396.163c.242-.344.65-.344.921-.185.137.08.251.204.3.36a.56.56 0 0 1-.057.445l-.04.065A162 162 0 0 1 9.651 15.682l-.006.006a.67.67 0 0 1-.463.187.67.67 0 0 1-.363-.107l-.1-.08A78 78 0 0 1 3.084 9.67H3.07l-.037-.046c-.265-.323-.163-.716.058-.94a.64.64 0 0 1 .423-.198.57.57 0 0 1 .466.222h.001l.671.788a78 78 0 0 0 4.494 4.78 159 159 0 0 0 10.572-13.16z"
})));
export default SvgValuepropsCheck2;